module.exports = __webpack_public_path__ + "img/cloud1.3f9b3d4d.webp";